import { useCallback, useEffect, useState } from "react"
import { useToggle } from "./useToggle"

export type UseIPReturn = {
    ip: string,
    loading: boolean
}

export const useIP = (): UseIPReturn => {
    const [ip, setIP] = useState('')
    const [loading, loadingControls] = useToggle(false)
    
    useEffect(() => {
        loadingControls.setTrue()
        fetch("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => setIP(data.ip))
            .catch((err) => console.error("Failed to get IP", err));

        loadingControls.setFalse()
    }, [])

    return {ip, loading}
}